import api from './api';

/**
 * EDI Invoicing Setup (cms.edi_invoicehistoryrecno) — create/update keyed by billto.
 * The grid is the read-only /tablemaint engine (key 'edi-invoice-setup'); writes go to the
 * billto-keyed router, which translates the entered Starting Invoice # (masterpro) into the
 * stored invoicehistoryrecno.
 */
export interface InvoiceSetupBody {
  billto?: number;
  masterpro?: string;
  edihandle204?: string;
  invmovetype?: string[];
}

export async function createInvoiceSetup(body: InvoiceSetupBody): Promise<void> {
  await api.post('/edi-invoice-setup', body);
}

export async function updateInvoiceSetup(billto: number, body: InvoiceSetupBody): Promise<void> {
  await api.put(`/edi-invoice-setup/${billto}`, body);
}

// Distinct edi_orders EDI handles for the "Required EDI Handle" select. Static reference
// list — cache the (~0.7s) fetch in module scope so it's paid once per session.
let handlesCache: Promise<{ value: string; label: string }[]> | null = null;
export function getEdiOrderHandles(): Promise<{ value: string; label: string }[]> {
  if (!handlesCache) {
    handlesCache = api
      .get<{ value: string; label: string }[]>('/cms-lookups/edi-order-handles')
      .then((r) => r.data)
      .catch((err) => { handlesCache = null; throw err; });
  }
  return handlesCache;
}
